import { useState, useMemo } from 'react';
import type { Dispatch, SetStateAction } from 'react';

import type { MachineSingle } from 'app/dataTypes/vending/Machines.types';
import { defaultVendingMachineKind } from 'app/dataTypes/vending/MachineKind.types';


const defaultState: MachineSingle = {
  id: 0,
  title: '',
  number: '',
  modelId: 0,
  versionId: 0,
  kind: defaultVendingMachineKind,
  orgId: 0,
  buildingId: 0,
  salePointId: 0,
  placeId: '',
};

export type VendingMachineSingle = [
  MachineSingle,
  Dispatch<SetStateAction<MachineSingle>>,
  () => void
]
export const defaultVendingMachineSingle: VendingMachineSingle = [defaultState, () => {}, () => {}];

export default function useVendingMachineSingle(): VendingMachineSingle {
  const [state, setState] = useState<MachineSingle>(defaultState);

  const memoized: VendingMachineSingle = useMemo(() => {
    const clear = () => {
      setState(defaultState);
    };

    return [state, setState, clear];
  }, [state, setState]);

  return memoized;
}
